/* eslint-disable no-console */

// 自动注册由 @vue/cli-plugin-pwa 生成的 Service Worker
// 构建后在生产环境 (process.env.NODE_ENV === 'production') 生效

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  // 监听 Service Worker 控制器变化，自动刷新页面获取最新版本
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    console.log('检测到新版本已激活，正在刷新页面...');
    window.location.reload();
  });

  window.addEventListener('load', () => {
    const swUrl = `${process.env.BASE_URL}service-worker.js`;

    navigator.serviceWorker
      .register(swUrl)
      .then(registration => {
        console.log('Service worker registered:', registration);

        // 监听更新
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (!installingWorker) return;
          installingWorker.onstatechange = () => {
            if (installingWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                console.log('检测到新版本，Service Worker 将自动激活并刷新页面');
              } else {
                console.log('首次安装，内容已缓存以供离线使用');
              }
            }
          };
        };
      })
      .catch(error => {
        console.error('Service worker 注册失败:', error);
      });
  });
}
